'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _flattenRuns = require('./flattenRuns');

var _flattenRuns2 = _interopRequireDefault(_flattenRuns);

var _AttributedString = require('../models/AttributedString');

var _AttributedString2 = _interopRequireDefault(_AttributedString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontSubstitution = function fontSubstitution(engines) {
  return function (attributedString) {
    var string = attributedString.string,
        runs = attributedString.runs;

    return engines.fontSubstitutionEngine.getRuns(string, runs);
  };
};

var scriptItemization = function scriptItemization(engines) {
  return function (attributedString) {
    return engines.scriptItemizer.getRuns(attributedString.string);
  };
};

var preprocessRuns = function preprocessRuns(engines) {
  return function (attributedString) {
    var fontRuns = fontSubstitution(engines)(attributedString);
    var scriptRuns = scriptItemization(engines)(attributedString);
    var stringRuns = attributedString.runs.map(function (run) {
      var _run$attributes = run.attributes,
          font = _run$attributes.font,
          attributes = (0, _objectWithoutProperties3.default)(_run$attributes, ['font']);

      return (0, _extends3.default)({}, run, { attributes: attributes });
    });

    var runs = (0, _flattenRuns2.default)([].concat(stringRuns, fontRuns, scriptRuns));
    return new _AttributedString2.default(attributedString.string, runs);
  };
};

exports.default = preprocessRuns;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/layout/preprocessRuns.js
// module id = 859
// module chunks = 0